import React from 'react';
import { Box } from 'pounceV2';
import { useTheme } from '@mui/material';
import { dracula, prism } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { useThemeContext } from 'Source/contexts/themeContext';

const LazySyntaxHighlighter = React.lazy(() => import('./SyntaxHighlighter'));

type GenericCodeBlockProps = {
  language: string;
  children: React.ReactNode;
  'data-testid'?: string;
};

const GenericCodeBlockV3 = ({
  children,
  language,
  'data-testid': dataTestId,
}: GenericCodeBlockProps) => {
  const theme = useTheme();
  const { effectiveTheme } = useThemeContext();
  const codeStyle = effectiveTheme === 'light' ? prism : dracula;
  return (
    <React.Suspense
      fallback={
        <Box backgroundColor={theme.palette.tokens.background.neutral[5]}>
          Loading code block...
        </Box>
      }
    >
      <LazySyntaxHighlighter language={language} data-testid={dataTestId} style={codeStyle}>
        {String(children).replace(/\n$/, '')}
      </LazySyntaxHighlighter>
    </React.Suspense>
  );
};

export default React.memo(GenericCodeBlockV3);
